angular.
module('moebiusProadapt').
service('mbsResolver', ['$rootScope', '$http', '$route', '$location', '$window', 'mbsEtiService', 'mbsLookupService', function mbsResolver($rootScope, $http, $route, $location, $window, mbsEtiService, mbsLookupService) {

    function isForbidden(data){
        if( typeof data === 'string' && data.includes('access_is_forbidden')){
            if (!$location.absUrl().includes("forbidden")){
                $window.location.href = './forbidden';
            }
            return true;
        }
        return false;
    }

    function fnEtiConfiguration(url, params, store, callback){
        // return function($rootScope, $http, $route, $location) {

            console.log('Called eti configuration:');

            var etiId = $route.current.params.id;

            //-- cached
            if (mbsEtiService.isLoadedEti(etiId)) {
                console.log('Eti configuration taken from cache');
                return mbsEtiService.getConfigurationForEti(etiId);
            }

            // -- or query on server
            var newUrl = [url];
            _.each(params, function(defaultValue, key){
                //If we can find the value in the route, we use it
                if($route.current.params[key]){
                    newUrl.push($route.current.params[key]);
                }
                //If the "search" parameter has the key, we use it
                else if($location.search[key]){
                    newUrl.push($location.search[key]);
                }
                //Otherwise we use the default value, if present
                else if(defaultValue){
                    newUrl.push(defaultValue);
                }
            })
            var request = $http.get(newUrl.join('/') )
                .then(function(resp){
                    if(isForbidden(resp.data)){
                        return;
                    }
                    console.log('eti configuration queried on server',resp);
                    mbsEtiService.storeData(resp.data);

                    return mbsEtiService.getConfigurationForEti(etiId);

                });
            return request;
        // };
        }

    function fnEtiAllDynamicDropdown(url, params, store, callback){

        // return function($rootScope, $http, $route, $location, APP_VERSION) {

            var etiId = $route.current.params.id;

            // -- cached with provided etiId
            if (etiId && mbsLookupService.isLoadedEti(etiId)) {
                console.log('LookupData taken from cache');
                return mbsLookupService.getLookupListForEti(etiId);
            }

            // -- cached with etiId = null
            if (!etiId && mbsLookupService.hasBeenCalled()) {
                return;
            }

            // -- or query on server
            var newUrl = [url];
            var request = $http.get(newUrl.join('/') +'?version=' + APP_VERSION)
                .then(function(resp){
                    if(isForbidden(resp.data)){
                        return;
                    }

                    console.log('LookupData queried on server');
                    mbsLookupService.storeData(resp.data);

                    return mbsLookupService.getLookupListForEti(etiId);

                });
            return request;
        // };
        }

    function fnUrl(url, params, store, callback) {
        // return function($rootScope, $http, $route, $location)
        // {

            if ($location.absUrl().includes("forbidden")){
                return;
            }

            if(store && $rootScope[store]){
                return $rootScope[store];
            }

            var newUrl = [url];
            _.each(params, function(defaultValue, key){
                //If we can find the value in the route, we use it
                if($route.current.params[key]){
                    newUrl.push($route.current.params[key]);
                }
                //If the "search" parameter has the key, we use it
                else if($location.search[key]){
                    newUrl.push($location.search[key]);
                }
                //Otherwise we use the default value, if present
                else if(defaultValue){
                    newUrl.push(defaultValue);
                }
            });

            var request = $http.get(newUrl.join('/'))
                .then(function(resp){
                    if(isForbidden(resp.data)){
                        return;
                    }
                    if(store){
                        $rootScope[store] = resp.data;
                    }
                    if(callback){
                        callback($rootScope, resp.data);
                    }
                    return resp.data
                });
            return request;
        // };
    }

    return {
        etiConfiguration: fnEtiConfiguration,
        url: fnUrl,
        etiAllDynamicDropdown: fnEtiAllDynamicDropdown,
    };
}]);


// WEBPACK FOOTER //
// ./resources/assets/js/services/mbs-resolver.js